<template>
  <div class="atdw-categories">
    <div v-if="loading" class="loading">Loading categories...</div>

    <div v-else-if="currentStep === 1" class="category-background" :style="defaultBgStyle">
      <h2>{{ config.categoriesPage.heading }}</h2>
      <p>{{ config.categoriesPage.subheading }}</p>
      <div class="categories">
        <button
          v-for="category in parentCategories"
          :key="category.id"
          @click="selectParentCategory(category)"
          class="category-btn"
          v-html="category.name"
        ></button>
      </div>
    </div>

    <div
      v-else-if="currentStep === 2"
      class="category-background"
      :style="{ backgroundImage: `url(${getBackgroundImage(selectedCategory?.id)})` }"
    >
      <h2>{{ config.categoriesPage.heading }}</h2>
      <p>{{ config.categoriesPage.subheading }}</p>
      <div class="categories">
        <button
          v-for="category in parentCategories"
          :key="category.id"
          @click="selectParentCategory(category)"
          :class="['category-btn', { selected: selectedCategory?.id === category.id }]"
          v-html="category.name"
        ></button>
      </div>
      <div class="subcategory-section" v-if="subcategories.length">
        <p>{{ config.categoriesPage.subcategoryPrompt }}</p>
        <div class="categories">
          <button
            v-for="subcategory in subcategories"
            :key="subcategory.id"
            @click="selectSubcategory(subcategory)"
            class="category-btn subcategory-btn"
            v-html="subcategory.name"
          ></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useConfigStore } from "./stores/config.js";

export default {
  name: "CategoriesApp",
  data() {
    return {
      currentStep: 1,
      categories: [],
      selectedCategory: null,
      selectedSubcategory: null,
      loading: true,
    };
  },
  computed: {
    config() {
      return useConfigStore();
    },
    parentCategories() {
      const { stay, eatAndDrink, seeAndDo } = this.config.categories;
      const allowedIds = [stay, eatAndDrink, seeAndDo].filter(Boolean);
      return this.categories.filter((cat) => allowedIds.includes(cat.id));
    },
    subcategories() {
      if (!this.selectedCategory) return [];
      return this.categories.filter((cat) => cat.parent === this.selectedCategory.id);
    },
    defaultBgStyle() {
      const bg = this.config.categoriesPage.defaultBg;
      return bg ? { backgroundImage: `url(${bg})` } : {};
    },
  },
  async mounted() {
    try {
      const apiBaseUrl = this.config.apiBaseUrl;
      const response = await fetch(
        `${apiBaseUrl}/website_category?_fields=id%2Cname%2Cslug%2Cparent&per_page=100&hide_empty=true`,
      );
      this.categories = await response.json();
      this.loading = false;
    } catch (error) {
      console.error("Failed to fetch categories:", error);
      this.loading = false;
    }
  },
  methods: {
    selectParentCategory(category) {
      this.selectedCategory = category;
      this.currentStep = 2;
    },
    selectSubcategory(subcategory) {
      this.$el.dispatchEvent(
        new CustomEvent("subcategory-selected", {
          bubbles: true,
          composed: true,
          detail: {
            categoryId: this.selectedCategory.id,
            subcategoryId: subcategory.id,
          },
        }),
      );
    },
    getBackgroundImage(categoryId) {
      const { categories, categoriesPage } = this.config;
      const bgImages = categoriesPage.backgroundImages || {};
      const imageMap = {};

      if (categories.stay && bgImages.stay) imageMap[categories.stay] = bgImages.stay;
      if (categories.eatAndDrink && bgImages.eatAndDrink)
        imageMap[categories.eatAndDrink] = bgImages.eatAndDrink;
      if (categories.seeAndDo && bgImages.seeAndDo)
        imageMap[categories.seeAndDo] = bgImages.seeAndDo;

      return imageMap[categoryId] || categoriesPage.defaultBg || "";
    },
  },
};
</script>

<style scoped>
h2 {
  font-family: var(--vwc-font-heading, sans-serif);
  font-weight: 400;
}

.atdw-categories {
  width: 100vw;
  height: 100vh;
  margin: 0 auto;
  text-align: center;
  color: white;
}

.category-background {
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.category-background::after {
  /* content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.65);
  pointer-events: none; */
}

.category-background > * {
  position: relative;
  z-index: 1;
}

.categories {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
}

@media screen and (max-width: 768px) {
  .categories {
    flex-direction: column;
  }
}

button {
  padding: 10px 20px;
  border: 2px solid #fff;
  background: transparent;
  border-radius: 25px;
  cursor: pointer;
  font-size: 14px;
  color: #fff;
  font-weight: bold;
}

button:hover {
  background: #fff;
  color: #000;
  transition:
    background 0.3s,
    color 0.3s;
}

button.selected {
  color: #333;
  background: white;
}

.subcategory-section {
  margin-top: 30px;
  max-width: 800px;
}

.loading {
  text-align: center;
  padding: 50px;
  font-size: 18px;
}
</style>
